export default __webpack_public_path__ + "static/SRUS CS5 - Product Specifications & Technical Data-ecc23df9ed8fd667f75e20718269d597.pdf";